export default __webpack_public_path__ + "static/media/fechadura-tetra.d321ff07.png";